import axios from "axios";
import history from "../../history";
import { getTimeZone } from "../../utils/helper";

axios.defaults.baseURL = process.env.REACT_APP_FINAN_DOMAIN;
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const config = {
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "x-location-timezone": `UTC${getTimeZone()}`,
  },
};

const responseInterceptor = (res) => {
  return res.data;
};

const catchHandleErr = (err) => {
  if (err?.response?.status === 401) {
    history.push("/login");
    window.location.reload(true);
  }
  console.log(err);
};

export const request = {
  get: (url, params) => {
    return axios
      .get(url, params)
      .then(responseInterceptor)
      .catch(catchHandleErr);
  },
  post: (url, params, configCustom) => {
    return axios
      .post(url, params, configCustom || config)
      .then(responseInterceptor)
      .catch(catchHandleErr);
  },
  put: (url, params) => {
    return axios
      .put(url, params, config)
      .then(responseInterceptor)
      .catch(catchHandleErr);
  },
};
export default {
  request,
};
